import QRCode from 'qrcodejs2';

export default class QRCodeUtils {
    static createQRCode(dom,content){
        let text = content;
        return new QRCode(dom, {
          text: text, //二维码内容字符串
          width: 128, //图像宽度
          height: 128, //图像高度
          colorDark: '#000000', //二维码前景色
          colorLight: '#ffffff', //二维码背景色
          correctLevel: QRCode.CorrectLevel.H, //容错级别
        })
    }
}